import React, { useState } from 'react';
import { Button, Input } from 'reactstrap';
import moment from 'moment';

//Components
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';

//Helpers
import { showMessage, showQuestion } from '../../../../../helpers/message';
import mascaras from '../../../../../helpers/mascaras';
import { montarPayloadReajuste, validarPrevia } from '../../../../../helpers/reajusteInfracao';

//API
import infracoes_api from '../../../../../api/infracoes_api';

//Context
import { useAuth } from '../../../../../context/auth';

export default function TabelaRecalculoInfracoes({ tipofiscalizacao_Id, reajusteEmPreparo, setReajusteEmPreparo, loadInfracoes }) {
    const { setLoading } = useAuth();
    const [salvando, setSalvando] = useState(false);

    const { dados, previa } = reajusteEmPreparo;

    const alterarValor = (id, campo, valor) => {
        setReajusteEmPreparo(anterior => ({
            ...anterior,
            previa: anterior.previa.map(item => item.id === id ? { ...item, [campo]: mascaras.floatMask(valor) } : item)
        }));
    };

    const agendar = async () => {
        setSalvando(true);
        setLoading(true);
        try {
            const { data } = await infracoes_api.AgendarReajuste(montarPayloadReajuste(tipofiscalizacao_Id, dados, previa));
            const mensagem = data?.status === "Aplicado"
                ? "Reajuste aplicado com sucesso, pois a vigência começa hoje."
                : "Reajuste agendado com sucesso. Ele entrará em vigor na data de início da vigência.";

            showMessage("Aviso", mensagem, "success", () => {
                setReajusteEmPreparo(null);
                loadInfracoes();
            });
        } catch (err) {
            showMessage("Erro", err?.message ?? "Erro ao agendar o reajuste", "error", null);
        } finally {
            setLoading(false);
            setSalvando(false);
        }
    };

    const salvarRecalculo = () => {
        const mensagem = validarPrevia(previa);
        if (mensagem)
            return showMessage("Aviso", mensagem, "warning", null);

        const periodo = `${moment(dados.inicioVigencia).format("DD/MM/YYYY")} a ${moment(dados.fimVigencia).format("DD/MM/YYYY")}`;
        showQuestion(
            "Confirmar agendamento",
            `Agendar o reajuste de ${previa.length} infração(ões) com vigência de ${periodo}?`,
            "question",
            (confirmado) => { if (confirmado) agendar(); }
        );
    };

    const cancelarRecalculo = () => setReajusteEmPreparo(null);

    const inputValor = (item, campo) => (
        <Input
            type="text"
            bsSize="sm"
            className="text-end"
            value={item[campo]}
            onChange={(e) => alterarValor(item.id, campo, e.target.value)}
            disabled={salvando}
        />
    );

    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Valor Atual (UFM)", objectValue: "valorAnterior", align: "left" },
        {
            value: "Novo Valor (UFM)",
            objectValue: "valorNovo",
            align: "left",
            options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => inputValor(previa[dataIndex], "valorNovo")
            }
        },
        ...(dados.aplicarReincidencia ? [
            {
                value: "Reincidência Atual (UFM)",
                objectValue: "valorReincidenciaAnterior",
                align: "left",
                options: { filter: false, customBodyRenderLite: (dataIndex) => previa[dataIndex].valorReincidenciaAnterior ?? "-" }
            },
            {
                value: "Nova Reincidência (UFM)",
                objectValue: "valorReincidenciaNovo",
                align: "left",
                options: {
                    filter: false,
                    customBodyRenderLite: (dataIndex) => previa[dataIndex].valorReincidenciaNovo === null
                        ? "-"
                        : inputValor(previa[dataIndex], "valorReincidenciaNovo")
                }
            }
        ] : [])
    ];

    return (
        <>
            <p className="mb-2"><strong>Ato administrativo:</strong> {dados.atoAdministrativo}</p>
            <p className="mb-2"><strong>Observação:</strong> {dados.observacao}</p>

            <div className="d-flex justify-content-end mb-2">
                <Button color="success" onClick={salvarRecalculo} disabled={salvando}>Agendar reajuste</Button>
                <Button color="secondary" className="ms-2" onClick={cancelarRecalculo} disabled={salvando}>Cancelar</Button>
            </div>

            <TabelaListagem
                title={
                    <h5>
                        Prévia do Reajuste <span className='text-danger'>(Fator {dados.fatorCorrecao}, vigência {moment(dados.inicioVigencia).format("DD/MM/YYYY")} a {moment(dados.fimVigencia).format("DD/MM/YYYY")})</span>
                    </h5>
                }
                headers={headers}
                items={previa}
            />
        </>
    );
}
